
const nameList = [
    {
        entityField: "cardCode",
        showField: "卡号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "capName",
        showField: "卡类型",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "memName",
        showField: "会员名字",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "mne",
        showField: "助记码",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "memSex",
        showField: "性别",
        fieldWeight: 80,
        fieldType: "string",

    },
    {
        entityField: "memBirth",
        showField: "生日",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "memPhone",
        showField: "手机号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "memIdcard",
        showField: "身份证号",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "memState",
        showField: "状态",
        fieldWeight: 80,
        fieldType: "string",

    },
    {
        entityField: "memAddress",
        showField: "住址",
        fieldWeight: 180,
        fieldType: "string",

    },
    {
        entityField: "pointBalance",
        showField: "积分余额",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "storedBalance",
        showField: "储值余额",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "storeName",
        showField: "注册门店",
        fieldWeight: 100,
        fieldType: "string",

    },

  
  
   
   
    {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 180,
        fieldType: "string",

    },
    // {
    //     entityField: "storedPwd",
    //     showField: "储值密码",
    //     fieldWeight: 100,
    //     fieldType: "string",

    // },


]



const  searchList= [
    // {
    //     showField: "开始时间",
    //     entityField: "start",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "结束时间",
    //     entityField: "end",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
     {
        showField: "卡号",
        entityField: "cardCode",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
    {
        showField: "会员名字",
        entityField: "memName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
       
    {
        showField: "手机号",
        entityField: "memPhone",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

    
]




// 门店列表
// 业务员列表
export {nameList,searchList}